/**
 * rename the Object Property
 *
 * @param {string} oldPropName existing prop name in Object
 * @param {string} newPropName new prop name in Object
 * @return {Object} Object with new prop name
 */
export const renameProperty = (
	oldPropName,
	newPropName,
	{ [oldPropName]: val, ...obj }
) => {
	return { [newPropName]: val, ...obj };
};

/**
 * Checks if obj is an empty Object
 * @param {Object} obj
 * @return {Boolean} True if obj is empty. False if not
 */
export function isEmpty(obj) {
	return (
		typeof obj === "undefined" ||
		!obj ||
		(obj instanceof Array && obj.length === 0) ||
		(Object.keys(obj).length === 0 && obj.constructor === Object)
	);
}
